module.exports = require("./ur.d.ts");